import React from 'react'
import {Image} from 'semantic-ui-react'

import logo from '../../images/negosyonow-dark-logo.png'
import * as styles from './styles/header.module.css'
const Logo = () => (
	<Image
		size="mini"
		src={logo}
		alt="NegosyoNow"
		className={styles.logo}
	/>
)

export default Logo
